import React, { useEffect, useState } from "react";
import { Container as ContainerBase } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Dialog } from 'primereact/dialog';
import { createApplication } from "api/application";

const Container = tw(ContainerBase)`min-h-screen bg-gray-100 text-gray-900 font-medium flex justify-center items-center`;
const Content = tw.div`bg-white rounded-2xl shadow-lg w-full max-w-2xl p-8`;
const Heading = tw.h1`text-3xl font-bold mb-6 text-center text-pbsGreen-900`;
const Form = tw.form`space-y-5`;
const Input = tw.input`w-full px-4 py-3 rounded-md bg-gray-100 border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-pbsGreen-500 focus:bg-white`;
const Label = tw.label`block text-sm font-semibold text-gray-700`;
const Field = tw.div`space-y-2`;
const SuccessMessage = tw.div`text-green-700 bg-green-100 border border-green-300 rounded-md px-4 py-3 text-sm text-center mt-6`;
const FailMessage = tw.div`text-pbsOrange-700 bg-pbsOrange-100 border border-pbsOrange-300 rounded-md px-4 py-3 text-sm text-center mt-6`;

const SubmitButton = styled.button`
  ${tw`w-full py-3 rounded-md bg-pbsGreen-500 text-white font-semibold text-sm hover:bg-pbsGreen-600 transition duration-300`}
`;

export default function JobApplicationModal({ jobId, jobTitle, visible, setVisible }) {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [telephone, setTelephone] = useState('');
  const [resumeFile, setResumeFile] = useState(null);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [failMessage, setFailMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("fullname", fullName);
    formData.append("email", email);
    formData.append("telephone", telephone);
    formData.append("job_id", jobId);
    formData.append("job_title", jobTitle);
    if (resumeFile) formData.append("resume", resumeFile);
    
    createApplication(formData)
      .then(response => { 
        console.log('Application submitted successfully:', response);
        if (response.success) {
          setSuccess(true);
          setFail(false);
        } else {
          setSuccess(false);
          setFail(true);
          setFailMessage(response.message || 'Failed to submit application. Please try again later.');
        }
        // setVisible(false); // Optionally close the modal
      })
      .catch(error => { 
        setSuccess(false);
        setFail(true);
        setFailMessage('Failed to submit application. Please try again later.');
        console.error('Error submitting application:', error);
      });
  };

  return (
    <Dialog
      visible={visible}
      modal
      dismissableMask
      onHide={() => setVisible(false)}
      breakpoints={{ '960px': '90vw' }}
      style={{ width: '50vw' }}
      contentStyle={{ padding: 0, borderRadius: '1rem', maxHeight: '90vh', overflowY: 'auto' }}
      maskClassName="bg-black bg-opacity-50"
    >
      <div className="overflow-y-auto max-h-[85vh]">
        <Container>
          <Content>
            <Heading>Job Application</Heading>
            <Form onSubmit={handleSubmit}>
              <Field>
                <Label htmlFor="fullName">Full Name</Label>
                <Input
                  type="text"
                  id="fullName"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                />
              </Field>

              <Field>
                <Label htmlFor="email">Email</Label>
                <Input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Field>

              <Field>
                <Label htmlFor="telephone">Telephone Number</Label>
                <Input
                  type="tel"
                  id="telephone"
                  value={telephone}
                  onChange={(e) => setTelephone(e.target.value)}
                  required
                />
              </Field>

              <Field>
                <Label htmlFor="resume">Attach Resume</Label>
                <Input
                  type="file"
                  id="resume"
                  accept=".pdf,.doc,.docx"
                  onChange={(e) => setResumeFile(e.target.files[0])}
                  required
                />
              </Field>

              <SubmitButton type="submit">Submit Application</SubmitButton>
              {success && (
                <SuccessMessage>
                  🎉 Your application has been submitted successfully!
                </SuccessMessage>
              )}
              {fail && (
                <FailMessage>
                  {('❌ ' + failMessage) || '❌ Failed to submit application. Please try again later.'}
                </FailMessage>
              )}
            </Form>
          </Content>
        </Container>
      </div>
    </Dialog>
  );
}
